import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { AbstractFilterComponent } from './abstract-filter.component';
import { AutocompleteComponent } from '@pct-ng/form';
import type { AbstractDtoService } from '@pct-ng/core/dto';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CATEGORY_NAME_MAX_LENGTH_INJECTION_TOKEN } from '../../../injecton-token/category-name-max-length-injection-token';
import { SEARCH_TEXT_MAX_LENGTH_VALIDATOR } from '../../../constant/search-text-max-length';

@Component({
  selector: 'cappus-filter-category',
  imports: [AutocompleteComponent, ReactiveFormsModule],
  templateUrl: './filter-category.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterCategoryComponent<CATEGORY> extends AbstractFilterComponent<CATEGORY[] | null> {
  protected readonly SEARCH_TEXT_MAX_LENGTH_VALIDATOR = SEARCH_TEXT_MAX_LENGTH_VALIDATOR;
  readonly #CATEGORY_NAME_MAX_LENGTH = inject(CATEGORY_NAME_MAX_LENGTH_INJECTION_TOKEN);
  readonly service = input.required<AbstractDtoService<any, any, any, any, any>>();
  protected readonly searchControlValidators = Validators.maxLength(this.#CATEGORY_NAME_MAX_LENGTH);
}
